import {IBorderRadius} from '../incase-domain/common/borderRadius';

export function getBorderStyle(borderRadius?: IBorderRadius): string {
    const isSet = borderRadius?.upperLeft || borderRadius?.upperRight || borderRadius?.lowerLeft || borderRadius?.lowerRight;

    if (!borderRadius || !isSet) {
        return ``;
    }

    return `${borderRadius?.upperLeft || 0}em ${borderRadius?.upperRight || 0}em ${borderRadius?.lowerRight || 0}em ${
        borderRadius?.lowerLeft || 0
    }em`;
}

export function getBorderSize<T extends HTMLElement>(
    element?: T | null
): {
    horizontal: number;
    top: number;
    left: number;
    bottom: number;
    vertical: number;
    right: number;
} {
    if (!element)
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            horizontal: 0,
            vertical: 0,
        };

    const computedStyle = window.getComputedStyle(element);

    const borderLeftWidth = parseInt(computedStyle.borderLeftWidth, 10);
    const borderRightWidth = parseInt(computedStyle.borderRightWidth, 10);
    const borderTopWidth = parseInt(computedStyle.borderTopWidth, 10);
    const borderBottomWidth = parseInt(computedStyle.borderBottomWidth, 10);

    return {
        left: borderLeftWidth,
        right: borderRightWidth,
        top: borderTopWidth,
        bottom: borderBottomWidth,
        horizontal: borderLeftWidth + borderRightWidth,
        vertical: borderTopWidth + borderBottomWidth,
    };
}

export function getCssVariable(variableName: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
}
